import { render } from "./imgItem.vue?vue&type=template&id=3748dd5e"
import script from "./imgItem.vue?vue&type=script&lang=js"
export * from "./imgItem.vue?vue&type=script&lang=js"

import "./imgItem.vue?vue&type=style&index=0&id=3748dd5e&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__